import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PriceChartConstants } from "../../Constants/PriceChartConstants";
import LocalizationStore from "../../Stores/Localization/LocalizationStore";
import { RiTabTitle } from "../../Constants/RiSubCategoryType";

const { ActionTypes } = PriceChartConstants;

const SwingSize = ({ tab, disabled = false }) => {
  const dispatch = useDispatch();
  const [menuOptions, setMenuOptions] = useState([]);
  const viewsSettings = useSelector(
    (state) => state.RelatedInfoPanelReducers.RiPanelAI.aiSettings
  );
  const gutterSize = viewsSettings?.futureEvent?.gutterSize;
  const isDisabled = ((!viewsSettings || viewsSettings.futureEvent.useEpsRpsSettings) && tab === RiTabTitle.FutureEvents) || disabled;

  useEffect(() => {
    if (viewsSettings) {
      if (tab === RiTabTitle.HistoricalNews) {
        const zzSwingSizeSettings = [
          {
            periodicity: "Daily",
            headerKey: "tp_per_dly",
            quantityKey: "",
            quantityLabel: "%",
            activeItem: viewsSettings?.zigzagIndicator?.swingSize.Daily,
            valueOptions: [
              { value: 5, displayValue: "5" },
              { value: 10, displayValue: "10" },
              { value: 20, displayValue: "20" },
              { value: 30, displayValue: "30" },
            ],
          },
          {
            periodicity: "Weekly",
            headerKey: "tp_per_wkly",
            quantityKey: "",
            quantityLabel: "%",
            activeItem: viewsSettings?.zigzagIndicator?.swingSize.Weekly,
            valueOptions: [
              { value: 10, displayValue: "10" },
              { value: 15, displayValue: "15" },
              { value: 20, displayValue: "20" },
              { value: 30, displayValue: "30" },
            ],
          },
          {
            periodicity: "Monthly",
            headerKey: "tp_per_mnly",
            quantityKey: "",
            quantityLabel: "%",
            activeItem: viewsSettings?.zigzagIndicator?.swingSize.Monthly,
            valueOptions: [
              { value: 15, displayValue: "15" },
              { value: 20, displayValue: "20" },
              { value: 30, displayValue: "30" },
              { value: 40, displayValue: "40" },
            ],
          },
        ];
        setMenuOptions(zzSwingSizeSettings);
      } else {
        const futureEventSwingSizeSettings = [
          {
            periodicity: "Daily",
            headerKey: "tp_per_dly",
            quantityKey: "",
            quantityLabel: "qtrs",
            activeItem: gutterSize.Daily,
            valueOptions: [
              { value: 1, displayValue: "1" },
              { value: 2, displayValue: "2" },
              { value: 4, displayValue: "4" },
            ],
          },
          {
            periodicity: "Weekly",
            headerKey: "tp_per_wkly",
            quantityKey: "",
            quantityLabel: "qtrs",
            activeItem: gutterSize.Weekly,
            valueOptions: [
              { value: 1, displayValue: "1" },
              { value: 2, displayValue: "2" },
              { value: 4, displayValue: "4" },
              { value: 8, displayValue: "8" },
            ],
          },
          {
            periodicity: "Monthly",
            headerKey: "tp_per_mnly",
            quantityKey: "",
            quantityLabel: "years",
            activeItem: gutterSize.Monthly,
            valueOptions: [
              { value: 1, displayValue: "1" },
              { value: 2, displayValue: "2" },
            ],
          },
        ];
        setMenuOptions(futureEventSwingSizeSettings);
      }
    }
  }, [viewsSettings, gutterSize, gutterSize?.Weekly, gutterSize?.Daily, gutterSize?.Monthly]);

  const handleItemClick = (periodicity, value) => {
    if (tab === RiTabTitle.HistoricalNews) {
      dispatch({
        type: ActionTypes.UPDATE_ZZ_INDICATOR_SWING_SIZE,
        item: { periodicity, value },
      });
    } else {
      dispatch({
        type: ActionTypes.UPDATE_FUTURE_EVENT_GUTTER_SETTINGS,
        item: { periodicity, value },
      });
    }
  };

  const updateUseForwardEpsRpsSettings = (value) => {
    if (tab === RiTabTitle.FutureEvents) {
      dispatch({
        type: ActionTypes.UPDATE_USE_FORWARD_EPS_RPS,
        value,
      });
    }
  };

  const handleRestoreDefaults = () => {
    dispatch({
      type: ActionTypes.UPDATE_ZZ_INDICATOR_SWING_SIZE,
      item: { periodicity: "All", value: 0 },
    });
  };

  const renderMenu = (options) => {
    const {
      periodicity,
      headerKey,
      quantityKey,
      quantityLabel,
      valueOptions,
      activeItem,
    } = options;
    const isDisabled = ((!viewsSettings || viewsSettings.futureEvent.useEpsRpsSettings) && tab === RiTabTitle.FutureEvents) || disabled;

    return (
      <div className={`${isDisabled ? "option-disabled" : ""} ${isDisabled ? "gutter-disabled" : ""} fundamental-Lines-Menu`} key={periodicity} style={{ marginTop: "6px" }}>
        <div className="header">
          {LocalizationStore.getTranslatedData(headerKey, periodicity)}
        </div>
        <div className="itemsDiv">
          <ul className="fundamental-Lines-Options">
            {valueOptions.map((item, index) => (
              <li
                key={index}
                onClick={!isDisabled ? () => handleItemClick(periodicity, item.value) : null}
                className={!isDisabled && activeItem === item.value ? "menuItem active" : ""}
              >
                {item.displayValue}
              </li>
            ))}
          </ul>
        </div>
        <div className="quantity">
          {LocalizationStore.getTranslatedData(quantityKey, quantityLabel)}
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      { tab === RiTabTitle.FutureEvents ? (  
          <div className={`${disabled ? "option-disabled" : ""}`} style={{ marginLeft: "5px", marginBottom: "10px", marginTop: "5px" }}>
            <input
              className="check-style"
              type="checkbox"
              name="high_low_estimate"
              id="high_low_estimate"
              checked={!!viewsSettings?.futureEvent.useEpsRpsSettings}
              onChange={(e) => !disabled && updateUseForwardEpsRpsSettings(e.target.checked)}
            />
            <label className="eps-rps-label">Use Forward EPS & RPS Settings</label>
          </div>
        ) : null 
      }
      {menuOptions.map(renderMenu)}

      { tab === RiTabTitle.HistoricalNews &&
        <div className="restore-defaults" onClick={handleRestoreDefaults}>
          {LocalizationStore.getTranslatedData("resdef", "Restore Defaults")}
        </div>
      }
      <div className="clearfix"></div>
    </div>
  );
};

export default SwingSize;
